import * as React from "react";
import BreadcrumbHybrid from "./BreadcrumbHybrid";
import { BreadcrumbItem } from "./BreadcrumbList";
import type { TypeBreadcrumbProps } from "./BreadcrumbTypes";

/**
 * Breadcrumb component. Automatically routes between the Tailwind
 * implementation (preferred) and the styled-components implementation (for
 * consumers using system props or styled() extension).
 */
const Breadcrumb = (props: TypeBreadcrumbProps) => (
  <BreadcrumbHybrid {...props} />
);

Breadcrumb.Item = BreadcrumbItem;

export default Breadcrumb;
